import { defineComponent as _defineComponent } from 'vue'
import { ref,  onMounted } from 'vue';
import UserCardRoles from "@/components/administration/users/UserCardRoles.vue";
import ActiveTokensCardTable from "@/components/administration/users/ActiveTokensCardTable.vue";
import {  showServerError } from '@/utils';
import { getRoles } from "@/api/auth";
import { Affiliate } from "@/services/affiliates/Affiliate";
import { IUserV3 } from "@/api/types/user";

interface Props {
    affiliate: Affiliate,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateAdministration',
  props: {
    affiliate: null
  },
  setup(__props: any) {

const props = __props as {
    affiliate: Affiliate,
}


const loadingRoleCard = ref<boolean>(true);
const affiliateUser = ref<IUserV3>({});


onMounted(async () => {
    loadingRoleCard.value = true;
    try {
        affiliateUser.value = props.affiliate;
        affiliateUser.value.available = await getRoles();
        affiliateUser.value.account_type = 'affiliate';
    } catch (e) {
        showServerError(e, 'Не удалось получить список ролей');
    } finally {
        loadingRoleCard.value = false;
    }
});

return { __sfc: true,props, loadingRoleCard, affiliateUser, UserCardRoles, ActiveTokensCardTable }
}

})